module.exports = __webpack_public_path__ + "img/ic-risk.2786b0cd.svg";